<template>
  <div v-if="preloader.loading" class="preloader">
    <div class="spinner"></div>
  </div>
</template>

<script setup>
import { usePreloaderStore } from "@/store/preloader.js";

const preloader = usePreloaderStore();
</script>

<style scoped>
.preloader {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  z-index: 9999;
}
.spinner {
  width: 50px;
  height: 50px;
  border: 5px solid #ccc;
  border-top: 5px solid blue;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>